import { render, staticRenderFns } from "./ProjectCategoryEditForm.vue?vue&type=template&id=91e188d4&"
import script from "./ProjectCategoryEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectCategoryEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports